import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateEntityResponse } from "../../common/CreateEntityResponse";
import { CreateFramerateProfileRequest } from "./requests/CreateFramerateProfileRequest";
import { UpdateFramerateProfileRequest } from "./requests/UpdateFramerateProfileRequest";
import { GetFramerateProfilesListResponse } from "./responses/GetFramerateProfileListResponse";
import { GetFramerateProfilesLookupResponse } from "./responses/GetFramerateProfilesLookupResponse";

export const useFramerateProfilesApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/framerate-profiles`;

    const { httpPost, httpGet, httpPut } = useAuthorizedFetch();

    const createFramerateProfile = async (request: CreateFramerateProfileRequest): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}/create`, request);
    };

    const getFramerateProfileList = async (): Promise<GetFramerateProfilesListResponse> => {
        return httpGet<GetFramerateProfilesListResponse>(`${baseUrl}/get-list`);
    };

    const updateFramerateProfile = async (request: UpdateFramerateProfileRequest): Promise<void> => {
        return httpPut<void>(`${baseUrl}/update`, request);
    };

    const getFramerateProfilesLookup = async (): Promise<GetFramerateProfilesLookupResponse> => {
        return httpGet<GetFramerateProfilesListResponse>(`${baseUrl}/get-lookup`);
    };

    return {
        createFramerateProfile,
        getFramerateProfileList,
        updateFramerateProfile,
        getFramerateProfilesLookup
    };
};
